import { render, staticRenderFns } from "./codeView.vue?vue&type=template&id=5297c0a5&scoped=true"
import script from "./codeView.vue?vue&type=script&lang=js"
export * from "./codeView.vue?vue&type=script&lang=js"
import style0 from "./codeView.vue?vue&type=style&index=0&id=5297c0a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.6_cache-loader@4.1.0_webpack@4.47.0__css-loader@3.6._v3ikegxpyohwicxz2xngozg43i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5297c0a5",
  null
  
)

export default component.exports